import {BannerType} from 'shared/components/MessageBanner/Themes';

/**
 * General interfaces
 */

export enum OfferType {
  BANNER = 'banner',
  MODAL = 'modal',
  ABTEST = 'abtest'
}
export interface Offer {
  offerType: OfferType;
}

interface AEMMessage {
  name: string;
  heading: string;
  messageText: string;
}

/**
 * AEMMessageBanner interfaces
 */
interface AEMBannerMessage extends AEMMessage {
  type?: BannerType;
  dismissable?: string;
  location?: BannerLocation;
}

export type BannerLocation = 'header' | 'title';

export interface MessageBannerOffer extends Offer {
  aemMessage: AEMBannerMessage;
}
export const isMessageBannerOffer = (offer: Offer): offer is MessageBannerOffer => offer.offerType === OfferType.BANNER;

/**
 * AEMModal interfaces
 */

export interface ModalOffer extends Offer {
  aemMessage: AEMMessage;
}
export const isModalOffer = (offer: Offer): offer is ModalOffer => offer.offerType === OfferType.MODAL;

/**
 * ABTEST interface
 */

export interface ABTestOffer extends Offer {
  experienceName: string;
  experienceGroup: 'A' | 'B';
}
export const isABTestOffer = (offer: Offer): offer is ABTestOffer => offer.offerType === OfferType.ABTEST;
